module.exports = __webpack_public_path__ + "img/Automotive_Recall_3_Set.7ba58c0d.png";